import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CardType } from '@bciti/types';

@Component({
    selector: 'app-required-card',
    templateUrl: './required-card.component.html',
    styleUrls: ['./required-card.component.scss'],
})
export class RequiredCardComponent implements OnInit, OnChanges {
    @Input()
    card: FormGroup;

    @Input()
    subTypeEvent: Event;

    @Input()
    hasError: boolean = false;

    constructor() {}

    ngOnInit(): void {}

    getRequiredCardControls() {
        return (this.card.get('requiredCards') as FormArray).controls;
    }

    removeRequiredCard(index: number) {
        (this.card.get('requiredCards') as FormArray).removeAt(index);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes?.subTypeEvent?.currentValue?.availableSubTypes) {
            // To update the requiredSubTypes values if an availableSubType changes

            const requiredSubTypes: FormArray = this.card.get('requiredSubTypes') as FormArray;

            const availableSubTypesValues: string[] = (this.card.get('availableSubTypes') as FormArray).value;

            let requiredSubTypesValues: string[] = requiredSubTypes.value;
            requiredSubTypesValues = requiredSubTypesValues.filter((el) => {
                return availableSubTypesValues.indexOf(el) >= 0;
            });

            requiredSubTypes.setValue(requiredSubTypesValues);
        }
    }

    getCardTypes(): string[] {
        return Object.values(CardType).filter((cardType) => cardType !== this.card.value.type);
    }
}
